var __TEMP__ = require('./_baseToPairs.js');var baseToPairs = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getTag.js');var getTag = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_mapToArray.js');var mapToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_setToPairs.js');var setToPairs = __REQUIRE_DEFAULT__(__TEMP__);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = createToPairs;
